import { combineLatest } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import Drawer from '@/components/Dashboard/common/Drawer';
import CreateTransfer from './CreateTrasfer';
import ConfigureColumns from './ConfigureColumns';
import SelectSource, {
    ALLOWED_NOT_MARKETING_SOURCES,
    ALLOWED_ORGANIC,
    ALLOWED_ORGANIC_V2,
} from './SelectSource';
import DateFilterSetting from '@components/Dashboard/common/WidgetSettingPanel/options/dateFilter';

import PrevIcon from '@svgIcons/prev.svg';

import {
    checkIsPublic,
    checkSourceTableMode,
    // sortLongString
} from '@/utils/dashboard';
import { generateId, isValueExist } from '@/utils/utils';

import { ExportDataService } from '@/services';

import * as S from './style';
import iframeMixin from '@/mixins/iframe.js';
import { Iframe } from '@/styles/common.styled.component';
import { VERTICAL_SPACER } from '@/styles/common.styled.component';
import { IFRAME_EVENT_MESSAGE, REACT_BASE_URL } from '@consts';
import moment from 'moment';
import { secondPanelOpenSubject$ } from '@/components/Dashboard/common/WidgetSettingPanel/secondPanelOpenSubject$';
import { NOTI_TYPES } from '@/store/dashboardEdit';
import SelectStream, { CUSTOM_TABLE, FULL_ARCHITECTURE } from './SelectStream';
import { gtm, GTM_EVENT_NAME } from '@/utils/tracker/googleTagManager';
import withHMR from '@/utils/withHMR';
import {
    checkIsValidSchedule,
    checkHasDuplicateSchedules,
} from './SchedulesSettings/utils';

import {
    IconWrapper,
    TitleLabel,
} from '@/components/Dashboard/common/WidgetSettingPanel/options/styles';
import FilterIcon from '@svgIcons/filter.svg';
import {
    filterSelected,
    getAccountKey,
} from '@/components/Dashboard/common/WidgetSettingPanel';
import { getFieldLocale } from '@/utils/field';

export const NAME = 'name';
export const TRANFER_TYPE = 'transferType';
export const FREQUENCY = 'frequency';
export const TABLE_NAME = 'table_name';
export const SCHEDULES = 'schedules';

export const GSS_SELECTED = 'gss_selected';

export const {
    CREATE_TRANSFER,
    SELECT_SOURCE,
    EDIT_TRANSFER,
    DUPLICATE_TRANSFER,
    SELECT_STREAM,
    CONFIGURE_COLUMNS,
} = {
    CREATE_TRANSFER: 'CREATE_TRANSFER',
    SELECT_SOURCE: 'SELECT_SOURCE',
    EDIT_TRANSFER: 'EDIT_TRANSFER',
    DUPLICATE_TRANSFER: 'DUPLICATE_TRANSFER',
    SELECT_STREAM: 'SELECT_STREAM',
    CONFIGURE_COLUMNS: 'CONFIGURE_COLUMNS',
};

export const TYPE_MAP = {
    parsedPercentage: 'percentage',
    fullNumber: 'number',
};

const DEFAULT_DATE = Object.freeze({
    disabled: true,
    type: 'relative',
    values: { relative: { unit: 'Y', value: 1 } },
});

const GAS = ['googleAnalytics', 'googleAnalytics4'];

const REQUIRED_DIMENSION_CUSTOM_TABLE_WITH_MARKETRING_SOURCES = [
    'channel',
    'adAccount',
    'campaign',
    'adSet',
    'ad',
];

const dissocTemporaryId = R.map((field) => {
    if (String(field?.id).includes('temporary')) {
        return R.dissoc('id', field);
    }

    return field;
});

const CUSTOM_FIELD_ON_ARCHITENCURE_USER = [755681, 15167];

export const DESTINATION_TABLE_NAME_CONNECTORS = [
    'snowflake',
    'bigquery',
    'google sheets',
];

const ALLOWED_DATE_BREAKDOWN = ['day'];

export const DATA_TRANSFER_LIST_TYPE = {
    active: Boolean,
    canEdit: Boolean,
    dateFilter: Object,
    transferStatus: Object,
    dataTransferConfig: {
        workspace_id: Number,
        custom_name: String,
        data_to_transfer: Array,
        asset_id_list: Array,
        selected_breakdowns: Array,
        date_filter: Object,
        stream_type: String,
        selected_arch_levels: Array,
        destination_table_name: String,
        destination_connector_type: String,
        schedules: Array,
        created_at: Date,
        connection_id: Number,
        // meta: Object,
        // glue_job_id: String,
    },
    connectionConfiguration: Object,
};

export const ExportDataPanel = {
    name: 'ExportDataPanel',
    mixins: [iframeMixin],
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        transferList: {
            type: Array,
            default: R.always([]),
        },
        selectedItem: {
            type: Object, // DATA_TRANSFER_LIST_TYPE,
            default: () => ({}),
        },
        adsTableSources: {
            type: Array,
            default: R.always([]),
        },
        transferOptions: {
            type: Array,
            default: R.always([]),
        },
        tableAdAccounts: {
            type: Array,
            default: R.always([]),
        },
    },
    beforeDestroy() {
        this.removeIframeRef(this.$refs.iframeCalendar);
        this.removeIframeRef(this.$refs.iframePanel);
        this.loadChatbot();
    },
    data() {
        return {
            page: CREATE_TRANSFER,
            loading: false,
            formData: [],
            valueMap: {
                [NAME]: '',
                [TRANFER_TYPE]: '',
                [FREQUENCY]: {
                    value: 8,
                    display_name: '8h',
                },
                [TABLE_NAME]: '',
                [SCHEDULES]: [],
            },
            dropdownMap: {
                [TRANFER_TYPE]: false,
                [FREQUENCY]: false,
            },
            sourceList: [],
            metricList: [],
            breakdownList: [],
            isPreviewPanelActive: false,
            previewWidget: undefined,
            dateFilter: DEFAULT_DATE,
            iframeLayer: 'none',
            iframeListeners_: [
                {
                    eventType: IFRAME_EVENT_MESSAGE.ADD_NOTI_MSGS,
                    listener: (e) => {
                        this.addNotiMsg(e.data);
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.SAVE_WIDGET_DATE_FILTER,
                    listener: (e) => {
                        const { data } = e;
                        const { dateFilter = {} } = data;

                        this._dateFilter = dateFilter;
                    },
                },
                // Sync Account
                {
                    eventType: IFRAME_EVENT_MESSAGE.PAGE_LOAD_EVENT,
                    listener: () => {
                        if (this.account) {
                            this.postIframeMessage({
                                type: `SYNC_ACCOUNT`,
                                origin: `VUE`,
                                data: { account: this.account },
                            });
                        }
                        if (this.user) {
                            this.postIframeMessage({
                                type: `SYNC_USER`,
                                origin: `VUE`,
                                data: { user: this.user },
                            });
                        }
                    },
                },
                /**
                 * field panel
                 */
                {
                    eventType: IFRAME_EVENT_MESSAGE.TOGGLE_METRIC_PANEL,
                    listener: (e) => {
                        const { data } = e;
                        this.setMetricPanelData(data);
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.TOGGLE_BREAKDOWN_PANEL,
                    listener: (e) => {
                        const { data } = e;
                        this.setBreakdownPanelData(data);
                    },
                },
                {
                    eventType: IFRAME_EVENT_MESSAGE.SET_IFRAME_LAYER,
                    listener: (e) => {
                        this.iframeLayer = e.data?.layer ?? 'none';
                    },
                },
            ],
            streamType: CUSTOM_TABLE,
            selectedArchLevels: [],
            customFields: [],
            hasCustomFieldChanged: false,
            datastreamConnectionId: null,
            schemas: [],
            configurePanel: false,
        };
    },
    computed: {
        ...mapState('user', ['userAccountId']),
        ...mapGetters('user', ['user', 'account']),
        ...mapState('newDashboard', ['metricPanelData', 'breakdownPanelData']),
        ...mapGetters('newDashboard', ['tableAdAccountsByAccountKey']),
        confirmTextByPage() {
            switch (this.page) {
                case CREATE_TRANSFER: {
                    if (this.isSftp) {
                        return this.$t('COMMON.submit');
                    } else {
                        return this.$t('COMMON.next');
                    }
                }
                // case SELECT_SOURCE:
                //     return this.$t('COMMON.next');
                case SELECT_SOURCE:
                case DUPLICATE_TRANSFER:
                    return this.$t('COMMON.confirm');
                case EDIT_TRANSFER:
                    return this.$t('COMMON.change');
                case SELECT_STREAM:
                    return this.$t('COMMON.next');
                case CONFIGURE_COLUMNS:
                    return this.$t('COMMON.confirm');
            }
        },
        isUnblockPage() {
            return this.$route.name === 'DataTransfer';
        },
        _dateFilter: {
            get() {
                return !isValueExist(this.dateFilter) ||
                    this.dateFilter.disabled === true
                    ? DEFAULT_DATE
                    : this.dateFilter;
            },
            set(value) {
                this.dateFilter = value;
            },
        },
        queryParams() {
            const queryParams = {
                locale: this.language,
                country: this.globalUser.country,
                type: 'vue',
            };
            const cleanedQueryParamsEntries = Object.entries(
                queryParams
            ).filter(([_, value]) => !R.isNil(value));
            const cleanedQueryParams = Object.fromEntries(
                cleanedQueryParamsEntries
            );
            return new URLSearchParams(cleanedQueryParams).toString();
        },
        iframeUrl() {
            const fileExtension =
                process.env.NODE_ENV === `production` ? `.html` : ``;

            return `${REACT_BASE_URL}/calendar${fileExtension}?${this.queryParams}`;
        },
        iframePanelUrl() {
            const fileExtension =
                process.env.NODE_ENV === `production` ? `.html` : ``;

            return `${REACT_BASE_URL}/panels${fileExtension}?${this.queryParams}`;
        },
        over2Y() {
            const { _dateFilter } = this;

            if (_dateFilter.type !== 'range') {
                return false;
            } else {
                const from = R.path(['values', 'range', 'from'], _dateFilter);

                return moment(from).add(2, 'Y').isBefore(moment());
            }
        },
        transferType: R.pathOr({}, ['valueMap', TRANFER_TYPE]),
        transferName: R.pathOr('', ['transferType', 'name']),
        isSftp() {
            return this.transferName === 'SFTP';
        },
        selectedSources() {
            return R.filter(R.prop('selected'), this.sourceList);
        },
        isAnalytic() {
            return checkSourceTableMode(this.selectedSources) === 'analytic';
        },
        disabledReason() {
            switch (this.page) {
                case EDIT_TRANSFER:
                case SELECT_SOURCE: {
                    if (
                        this.streamType === CUSTOM_TABLE &&
                        isValueExist(this.selectedSources) &&
                        !this.isAnalytic
                    ) {
                        const hasRequiredBreakdown = R.any(
                            (breakdown) =>
                                breakdown.selected &&
                                REQUIRED_DIMENSION_CUSTOM_TABLE_WITH_MARKETRING_SOURCES.includes(
                                    breakdown.id
                                ),
                            this.breakdownList
                        );

                        return hasRequiredBreakdown
                            ? ''
                            : this.$t(
                                  'EXPORT_DATA.custom_table_select_least_one_dimension'
                              );
                    }
                }
            }

            return '';
        },
        hidePeriod() {
            const isMarketingSource = R.any(
                (item) => !ALLOWED_NOT_MARKETING_SOURCES.includes(item.channel),
                this.selectedSources
            );

            if (isMarketingSource) {
                const isArchitectureNotReport =
                    this.streamType === FULL_ARCHITECTURE &&
                    !this.selectedArchLevels.includes('report');

                if (isArchitectureNotReport) {
                    return true;
                }

                return false;
            }

            const hasPublicSource = R.any(checkIsPublic, this.selectedSources);

            if (hasPublicSource) {
                return true;
            }

            const selectedBreakdowns = R.filter(
                (breakdown) => breakdown.selected,
                this.breakdownList
            );
            const hasDateBreakdown = R.any(
                (breakdown) => ALLOWED_DATE_BREAKDOWN.includes(breakdown.id),
                selectedBreakdowns
            );

            if (!selectedBreakdowns.length) {
                return false;
            }

            return !hasDateBreakdown;
        },
        customFieldOnArchitectureUser() {
            return (
                this.isCustomFieldUser &&
                CUSTOM_FIELD_ON_ARCHITENCURE_USER.includes(
                    Number(this.cAccountId)
                )
            );
        },
        allowedNotMarketingSource() {
            const accountId = Number(this.cAccountId);
            return [
                ...ALLOWED_NOT_MARKETING_SOURCES,
                ...(accountId === 15167 || accountId === 1082841
                    ? ['tiktokOrganic', 'googleTrends', 'googleKeywordPlanner']
                    : []),
                ...(accountId === 15167 || accountId === 1160401
                    ? ['cafe24AdEffect']
                    : []),
            ];
        },
    },

    methods: {
        ...mapMutations('view', ['setNotiMsgs', 'addNotiMsg']),
        ...mapMutations('newDashboard', [
            'setMetricPanelData',
            'setBreakdownPanelData',
        ]),
        ...mapActions('iframe', [
            'postIframeMessage',
            'addIframeRef',
            'removeIframeRef',
        ]),
        renderContentsByPage() {
            const {
                loading,
                valueMap,
                dropdownMap,
                formData,
                sourceList,
                metricList,
                page,
                adsTableSources,
                transferOptions,
                selectedItem,
                breakdownList,
                tableAdAccounts,
                isAnalytic,
                transferList,
                streamType,
                selectedArchLevels,
                customFields,
                isCustomFieldUser,
                transferName,
                customFieldOnArchitectureUser,
                allowedNotMarketingSource,
                schemas,
            } = this;

            switch (page) {
                case CREATE_TRANSFER: {
                    return [
                        <CreateTransfer
                            formData={formData}
                            valueMap={valueMap}
                            dropdownMap={dropdownMap}
                            page={page}
                            transferOptions={transferOptions}
                            selectedItem={selectedItem}
                            transferList={transferList}
                            on={{
                                loading: (value) => (this.loading = value),
                                setValueMap: (value) => (this.valueMap = value),
                                setDropdownMap: (value) =>
                                    (this.dropdownMap = value),
                                setFormData: (value) => (this.formData = value),
                            }}
                        />,
                    ];
                }
                case SELECT_SOURCE: {
                    return [
                        <SelectSource
                            valueMap={valueMap}
                            loading={loading}
                            sourceList={sourceList}
                            metricList={metricList}
                            page={page}
                            adsTableSources={adsTableSources}
                            breakdownList={breakdownList}
                            tableAdAccounts={tableAdAccounts}
                            isAnalytic={isAnalytic}
                            streamType={streamType}
                            selectedArchLevels={selectedArchLevels}
                            customFields={customFields}
                            isCustomFieldUser={isCustomFieldUser}
                            transferName={transferName}
                            customFieldOnArchitectureUser={
                                customFieldOnArchitectureUser
                            }
                            allowedNotMarketingSource={
                                allowedNotMarketingSource
                            }
                            on={{
                                loading: (value) => (this.loading = value),
                                setSourceList: (value) =>
                                    (this.sourceList = value),
                                setMetricList: (value) =>
                                    (this.metricList = value),
                                setPreviewWidget: (v) =>
                                    (this.previewWidget = v),
                                setBreakdownList: (v) => {
                                    this.breakdownList = v;
                                },
                                setArchLevels: (v) =>
                                    (this.selectedArchLevels = v),
                                setCustomFields: (v) => {
                                    this.customFields = v;
                                },
                                setValueMap: (value) => (this.valueMap = value),
                            }}
                        />,
                        this.renderPeriod(),
                    ];
                }
                case EDIT_TRANSFER:
                case DUPLICATE_TRANSFER: {
                    return [
                        <CreateTransfer
                            formData={formData}
                            valueMap={valueMap}
                            dropdownMap={dropdownMap}
                            page={page}
                            transferOptions={transferOptions}
                            selectedItem={selectedItem}
                            breakdownList={breakdownList}
                            streamType={streamType}
                            on={{
                                loading: (value) => (this.loading = value),
                                setValueMap: (value) => (this.valueMap = value),
                                setDropdownMap: (value) =>
                                    (this.dropdownMap = value),
                                setFormData: (value) => (this.formData = value),
                                setStreamType: (value) =>
                                    (this.streamType = value),
                            }}
                        />,
                        <SelectSource
                            valueMap={valueMap}
                            loading={loading}
                            sourceList={sourceList}
                            metricList={metricList}
                            page={page}
                            adsTableSources={adsTableSources}
                            breakdownList={breakdownList}
                            tableAdAccounts={tableAdAccounts}
                            isAnalytic={isAnalytic}
                            streamType={streamType}
                            selectedArchLevels={selectedArchLevels}
                            customFields={customFields}
                            isCustomFieldUser={isCustomFieldUser}
                            transferName={transferName}
                            customFieldOnArchitectureUser={
                                customFieldOnArchitectureUser
                            }
                            allowedNotMarketingSource={
                                allowedNotMarketingSource
                            }
                            on={{
                                loading: (value) => (this.loading = value),
                                setSourceList: (value) =>
                                    (this.sourceList = value),
                                setMetricList: (value) =>
                                    (this.metricList = value),
                                setPreviewWidget: (v) =>
                                    (this.previewWidget = v),
                                setBreakdownList: (v) =>
                                    (this.breakdownList = v),
                                setArchLevels: (v) =>
                                    (this.selectedArchLevels = v),
                                setCustomFields: (v) => {
                                    this.customFields = v;
                                },
                                setHasCustomFieldChanged: (v) => {
                                    this.hasCustomFieldChanged = v;
                                },
                                setValueMap: (value) => (this.valueMap = value),
                            }}
                        />,
                        // this.renderTargetFieldSetting(),
                        this.renderPeriod(),
                    ];
                }
                case SELECT_STREAM: {
                    return (
                        <SelectStream
                            streamType={streamType}
                            page={page}
                            on={{
                                setStreamType: (value) =>
                                    (this.streamType = value),
                            }}
                        />
                    );
                }
                case CONFIGURE_COLUMNS: {
                    return (
                        <ConfigureColumns
                            metricList={metricList}
                            schemas={schemas}
                            on={{
                                setMetricList: (value) =>
                                    (this.metricList = value),
                                setSchemas: (value) => (this.schemas = value),
                            }}
                            breakdowns={breakdownList}
                            streamType={this.streamType}
                            isAnalytic={this.isAnalytic}
                        />
                    );
                }
            }
        },
        renderPeriod() {
            if (this.hidePeriod) {
                return null;
            }

            const firstSource = R.compose(
                R.defaultTo({}),
                R.head
            )(this.selectedSources);
            const firstAccountKey = getAccountKey(firstSource);

            const selectedSource = firstAccountKey
                ? this.tableAdAccountsByAccountKey[firstAccountKey] || {}
                : {};

            const hasDateSetting = R.propSatisfies(
                (setting) => Boolean(setting?.dateField && setting?.dateFormat),
                'settings',
                selectedSource
            );

            const allowedCustomSources = [
                ...GAS,
                ...ALLOWED_ORGANIC,
                ...ALLOWED_ORGANIC_V2,
            ].includes(selectedSource.channel);

            const isCustom = isValueExist(this.selectedSources)
                ? this.isAnalytic
                : this.streamType === CUSTOM_TABLE;

            const disabled =
                isCustom && !allowedCustomSources ? !hasDateSetting : false;

            if (disabled) return null;

            const uiDisabled = this.page === EDIT_TRANSFER && this.isAnalytic;

            return (
                <S.PeriodWrapper>
                    <DateFilterSetting
                        widgetDateFilter={this._dateFilter}
                        disableComparison={true}
                        noTooltip={true}
                        infoTooltipText={
                            this.over2Y
                                ? this.$t('EXPORT_DATA.over_max_period_warning')
                                : ''
                        }
                        onUpdate={({ widgetDateFilter }) => {
                            this._dateFilter = widgetDateFilter;
                        }}
                        uiDisabled={uiDisabled}
                    />
                    <S.PeriodWarning>
                        {'* ' + this.$t('EXPORT_DATA.period_warning_text')}
                    </S.PeriodWarning>
                </S.PeriodWrapper>
            );
        },
        async onConfirmByPage() {
            if (!this.checkIsValidByPage()) return;

            const {
                valueMap,
                formData,
                metricList,
                setNotiMsgs,
                makeReason,
                getCellType,
                transferName,
                isSftp,
                submitNotify,
                breakdownList,
                selectedSources,
                selectedItem = {},
                customFields,
            } = this;

            if (isSftp) {
                return submitNotify();
            }

            let connectionConfig = R.compose(
                R.map((item) => {
                    if (item.type === 'integer') {
                        return Number(item.value);
                    }

                    return item.value;
                }),
                R.indexBy(R.prop('key'))
            )(formData);

            let databaseType = transferName.toLowerCase();
            if (databaseType.includes('google sheets')) {
                connectionConfig = selectedItem.isDuplicate
                    ? R.find(
                          R.propEq(
                              'spreadsheetId',
                              R.path(
                                  ['connectionConfiguration', 'spreadsheet_id'],
                                  selectedItem
                              )
                          ),
                          formData
                      )
                    : formData?.[0]?.value;
            }

            const destinationConfig = {
                connectionConfig,
                databaseType,
            };

            const schedules = R.filter(isValueExist, valueMap[SCHEDULES]);

            switch (this.page) {
                case CREATE_TRANSFER: {
                    try {
                        this.loading = true;

                        const result = await ExportDataService.checkTransferV2({
                            datastreamName: valueMap['name'],
                            destinationConfig,
                        });

                        this.datastreamConnectionId =
                            result.datastreamConnectionId;
                        this.page = SELECT_STREAM;
                    } catch (e) {
                        const reason = makeReason(e);
                        setNotiMsgs([
                            {
                                type: 'FAIL',
                                reasons: [reason],
                            },
                        ]);
                    } finally {
                        this.loading = false;
                    }

                    break;
                }
                case SELECT_STREAM: {
                    this.page = SELECT_SOURCE;
                    break;
                }
                // case SELECT_SOURCE:
                // this.page = CONFIGURE_COLUMNS;
                // break;
                case SELECT_SOURCE:
                case DUPLICATE_TRANSFER:
                case CONFIGURE_COLUMNS: {
                    const assetIdList = R.pluck('assetId', selectedSources);

                    const userSelectedColumnList = R.compose(
                        R.map(
                            R.compose(
                                (v) =>
                                    R.assoc(
                                        'type',
                                        TYPE_MAP[getCellType(v.name)] ||
                                            getCellType(v.name),
                                        v
                                    ),
                                R.pick(['name'])
                            )
                        ),
                        R.uniqBy(R.prop('name')),
                        filterSelected
                    )(metricList);

                    const refinedSchemasParam = this.schemas.map(
                        (value, idx) => ({
                            ...value,
                            order: idx,
                        })
                    );

                    const schemas = this.selectedArchLevels.includes('report')
                        ? {
                              report: refinedSchemasParam,
                          }
                        : {
                              customTable: refinedSchemasParam,
                          };

                    const params = {
                        name: valueMap[NAME],
                        // schedule: {},
                        schedules,
                        assetIdList,
                        userSelectedColumnList:
                            this.streamType === FULL_ARCHITECTURE
                                ? this.selectedArchLevels.includes('report')
                                    ? userSelectedColumnList
                                    : []
                                : userSelectedColumnList,
                        destinationConfig,
                        streamType: this.streamType,
                        breakdowns: R.compose(
                            R.pluck('id'),
                            R.filter(R.prop('selected'))
                        )(breakdownList),
                        channel: R.compose(
                            R.head,
                            R.pluck('channel')
                        )(selectedSources),
                        ...(this.streamType === FULL_ARCHITECTURE && {
                            selectedArchLevels: this.selectedArchLevels,
                        }),
                        ...(this.streamType === CUSTOM_TABLE &&
                            DESTINATION_TABLE_NAME_CONNECTORS.includes(
                                databaseType
                            ) && {
                                destinationTableName: valueMap[TABLE_NAME],
                            }),
                        ...(!this.hidePeriod && {
                            dateFilter: this.dateFilter,
                        }),
                        connectionId: this.datastreamConnectionId,
                        // schemas,
                    };

                    if (!isValueExist(params.dateFilter)) {
                        delete params.dateFilter;
                    }

                    try {
                        this.loading = true;

                        let refinedParams = {
                            ...params,
                        };

                        if (this.isCustomFieldUser) {
                            const fields =
                                await ExportDataService.createCustomField(
                                    dissocTemporaryId(this.customFields)
                                );

                            refinedParams = {
                                ...refinedParams,
                                ...((this.streamType === CUSTOM_TABLE ||
                                    this.customFieldOnArchitectureUser) &&
                                    isValueExist(customFields) && {
                                        customFieldIds: R.pluck('id', fields),
                                    }),
                            };
                        }

                        const data = await ExportDataService.addTransferV2(
                            refinedParams
                        );

                        gtm.logEvent(GTM_EVENT_NAME.DATA_STREAM_CREATED, {
                            id: data?.id || '',
                            name: params.name || '',
                            connector_type: params.channel || '',
                        });

                        setNotiMsgs([{ type: 'SUCCESS' }]);

                        this.$emit('setPageLoading', true);
                        this.$emit('fetchList');
                        this.$emit('close');
                    } catch (e) {
                        const reason = makeReason(e);

                        setNotiMsgs([{ type: 'FAIL', reasons: [reason] }]);
                    } finally {
                        this.loading = false;
                    }

                    break;
                }
                case EDIT_TRANSFER: {
                    const {
                        active,
                        dataTransferConfig: {
                            custom_name = '',
                            connection_id,
                            id,
                        } = {},
                    } = this.selectedItem;

                    const assetIdList = selectedSources.map(
                        R.compose(R.prop('assetId'))
                    );

                    const userSelectedColumnList = R.compose(
                        R.map(
                            R.compose(
                                (v) =>
                                    R.assoc(
                                        'type',
                                        TYPE_MAP[getCellType(v.name)] ||
                                            getCellType(v.name),
                                        v
                                    ),
                                R.pick(['name'])
                            )
                        ),
                        R.uniqBy(R.prop('name')),
                        filterSelected
                    )(metricList);

                    const refinedSchemasParam = this.schemas.map(
                        (value, idx) => ({
                            ...value,
                            order: idx,
                        })
                    );

                    const schemas = this.selectedArchLevels.includes('report')
                        ? {
                              report: refinedSchemasParam,
                          }
                        : {
                              customTable: refinedSchemasParam,
                          };

                    const params = {
                        active,
                        schedules,
                        dataTransferName: custom_name,
                        userSelectedColumnList,
                        assetIdList,
                        streamType: this.streamType,
                        breakdowns: R.compose(
                            R.pluck('id'),
                            R.filter(R.prop('selected'))
                        )(breakdownList),
                        ...(this.streamType === FULL_ARCHITECTURE && {
                            selectedArchLevels: this.selectedArchLevels,
                        }),
                        ...(this.streamType === CUSTOM_TABLE &&
                            DESTINATION_TABLE_NAME_CONNECTORS.includes(
                                databaseType
                            ) && {
                                destinationTableName: valueMap[TABLE_NAME],
                            }),
                        ...(!this.hidePeriod && {
                            dateFilter: this.dateFilter,
                        }),
                        hasCustomFieldChanged: this.hasCustomFieldChanged,
                        connectionId: connection_id,
                        // schemas,
                    };

                    if (!isValueExist(params.dateFilter)) {
                        delete params.dateFilter;
                    }

                    try {
                        this.loading = true;

                        let refinedParams = {
                            ...params,
                        };

                        if (this.isCustomFieldUser) {
                            const idDissocedFields = dissocTemporaryId(
                                this.customFields
                            );

                            const [existingFields = [], newFields = []] =
                                R.partition(R.prop('id'), idDissocedFields);

                            const createdFields = isValueExist(newFields)
                                ? await ExportDataService.createCustomField(
                                      newFields
                                  )
                                : [];

                            const fields = R.compose(
                                R.sort(R.ascend(R.prop('id'))),
                                R.uniqBy(R.prop('id'))
                            )([
                                ...(createdFields || []),
                                ...(existingFields || []),
                            ]);

                            if (
                                this.streamType === CUSTOM_TABLE ||
                                this.customFieldOnArchitectureUser
                            ) {
                                await ExportDataService.updateCustomFieldsByStream(
                                    {
                                        id,
                                        fields: fields || [],
                                    }
                                );
                            }

                            refinedParams = {
                                ...refinedParams,
                                ...((this.streamType === CUSTOM_TABLE ||
                                    this.customFieldOnArchitectureUser) && {
                                    customFieldIds: R.pluck('id', fields),
                                }),
                            };

                            await ExportDataService.updateTransferV2(
                                refinedParams
                            );
                        } else {
                            await ExportDataService.updateTransferV2(
                                refinedParams
                            );
                        }

                        setNotiMsgs([{ type: 'SUCCESS' }]);

                        this.$emit('setSelectedItem', {});
                        this.$emit('setPageLoading', true);
                        this.$emit('fetchList');
                        this.$emit('close');
                    } catch (e) {
                        console.error(e);
                        const reason = makeReason(e);

                        setNotiMsgs([{ type: 'FAIL', reasons: [reason] }]);
                    } finally {
                        this.loading = false;
                    }

                    break;
                }
            }
        },
        makeReason(e) {
            const {
                code = '',
                message = '',
                properties = {},
            } = R.pathOr({}, ['response', 'data'], e);

            let reason = message;

            switch (code) {
                case 'NOT_SUPPORTED_METRIC':
                case 'METRICS_NOT_SUPPORTED':
                case 'SHOULD_BE_ONLY_BREAKDOWN':
                case 'MISSING_DIMENSIONS_OR_METRICS_FOR_CUSTOM_FIELD':
                case 'DUPLICATE_COLUMN_NAMES': {
                    const { relavantBreakdownsOrFields = '' } = properties;

                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        relavantBreakdownsOrFields: relavantBreakdownsOrFields
                            .map((metric) => {
                                const func = getFieldLocale.bind(this);
                                const translated = func(metric);

                                return translated;
                            })
                            .join(', '),
                    });
                    break;
                }
                case 'MISSING_PAIRING_FIELDS': {
                    const { level = '', pairingField = '' } = properties;
                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        level: this.$t(`METRICS.${level}`),
                        paringField: getFieldLocale.call(this, pairingField),
                    });
                    break;
                }
                case 'MISSING_BREAKDOWNS': {
                    const func = getFieldLocale.bind(this);

                    const { level = '', metric = '' } = properties;

                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        level: this.$t(`METRICS.${level}`),
                        metric: func(metric),
                    });

                    break;
                }
                case 'ONLY_SUPPORTED_IN_ARCHITECTURE': {
                    const func = getFieldLocale.bind(this);

                    const { levels = '', metric = '' } = properties;

                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        levels: levels
                            .map((level) => this.$t(`METRICS.${level}`))
                            .join(', '),
                        metric: func(metric),
                    });

                    break;
                }
                case 'NOT_SUPPORTED_METRIC_FULL_ARCH_REPORT': {
                    const func = getFieldLocale.bind(this);

                    const { metric = '' } = properties;

                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        metric: func(metric),
                    });

                    break;
                }
                case 'NO_COMPATIBLE_DIMENSIONS': {
                    const { detailBreakdown = '', otherDetailBreakdowns = '' } =
                        properties;

                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        detailBreakdown: getFieldLocale.call(this, detailBreakdown),
                        otherDetailBreakdowns: otherDetailBreakdowns
                            .map((breakdown) => getFieldLocale.call(this, breakdown))
                            .join(', '),
                    });

                    break;
                }
                case 'NO_AVAILABLE_CHANNELS': {
                    const { detailBreakdown = '', nonAvailableChannels = '' } =
                        properties;

                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        detailBreakdown: getFieldLocale.call(this, detailBreakdown),
                        nonAvailableChannels: nonAvailableChannels
                            .map((channel) => this.$t(`CHANNEL.${channel}`))
                            .join(', '),
                    });

                    break;
                }
                case 'UNSUPPORTED_AGGREGATE_MARKETING_LEVEL': {
                    const { detailBreakdown = '', supportedLevels = '' } =
                        properties;

                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        detailBreakdown: getFieldLocale.call(this, detailBreakdown),
                        supportedLevels: supportedLevels
                            .map((level) => this.$t(`METRICS.${level}`))
                            .join(', '),
                    });

                    break;
                }
                case 'WRONG_FORMATTED_CUSTOM_FIELDS':
                case 'MAX_NUM_OF_BREAKDOWN_EXCEEDED':
                case 'OUT_OF_DATE_RANGE_SUPPORTED':
                case 'NO_AVAILABLE_DATA_FROM_SOURCE': {
                    reason = this.$t(`EXPORT_DATA.error_${code}`, {
                        ...properties,
                    });
                    break;
                }
                case 'INTERNAL_ERROR':
                    reason = this.$t('EXPORT_DATA.error_INTERNAL_ERROR');
                    break;

                default:
                    reason = this.translateOr(
                        `EXPORT_DATA.error_${code}`,
                        message
                    );

                    break;
            }

            return reason;
        },
        renderHeaderTextByPage() {
            return (
                <S.MainTitle slot="header">
                    <S.LeftWrapper>
                        <S.MainTitleTop>
                            {(this.page === SELECT_SOURCE ||
                                this.page === SELECT_STREAM ||
                                this.page === CONFIGURE_COLUMNS) && (
                                <PrevIcon
                                    v-view-box
                                    onClick={() => {
                                        switch (this.page) {
                                            case SELECT_SOURCE:
                                                this.page = SELECT_STREAM;
                                                break;
                                            case SELECT_STREAM:
                                                this.page = CREATE_TRANSFER;
                                                break;
                                            case CONFIGURE_COLUMNS:
                                                this.page = SELECT_SOURCE;
                                                break;
                                        }
                                    }}
                                />
                            )}
                            {(() => {
                                const transfetName = R.pathOr(
                                    '',
                                    ['dataTransferConfig', 'custom_name'],
                                    this.selectedItem
                                );

                                switch (this.page) {
                                    case CREATE_TRANSFER: {
                                        return this.$t(
                                            'EXPORT_DATA.panel_title_create_transfer'
                                        );
                                    }
                                    case SELECT_SOURCE: {
                                        return this.$t(
                                            'EXPORT_DATA.panel_title_select_source'
                                        );
                                    }
                                    case EDIT_TRANSFER: {
                                        return this.$t(
                                            'EXPORT_DATA.panel_title_edit_transfer',
                                            {
                                                name: transfetName,
                                            }
                                        );
                                    }
                                    case DUPLICATE_TRANSFER: {
                                        return this.$t(
                                            'EXPORT_DATA.panel_title_duplicate_transfer',
                                            {
                                                name: transfetName,
                                            }
                                        );
                                    }
                                    case SELECT_STREAM: {
                                        return this.$t(
                                            'EXPORT_DATA.panel_title_select_stream'
                                        );
                                    }
                                    case CONFIGURE_COLUMNS: {
                                        return this.$t(
                                            'EXPORT_DATA.panel_title_configure_columns'
                                        );
                                    }
                                }
                            })()}
                        </S.MainTitleTop>
                    </S.LeftWrapper>
                </S.MainTitle>
            );
        },
        checkIsValidByPage() {
            const shouldHaveTableName =
                DESTINATION_TABLE_NAME_CONNECTORS.includes(
                    this.transferName?.toLowerCase()
                ) && this.streamType === CUSTOM_TABLE
                    ? Boolean(this.valueMap[TABLE_NAME])
                    : true;

            const schedules = this.valueMap[SCHEDULES];
            const hasDuplicateSchedules = checkHasDuplicateSchedules(schedules);
            const isSchedulesValid =
                (schedules.length === 0 ||
                    schedules.some(checkIsValidSchedule)) &&
                !hasDuplicateSchedules;

            switch (this.page) {
                case DUPLICATE_TRANSFER:
                case CREATE_TRANSFER: {
                    if (this.transferName === 'SFTP') {
                        return true;
                    } else {
                        return (
                            R.all(
                                R.ifElse(
                                    R.prop('required'),
                                    R.propSatisfies(isValueExist, 'value'),
                                    R.T
                                ),
                                this.formData
                            ) &&
                            Boolean(this.valueMap[NAME]) &&
                            isSchedulesValid &&
                            (this.page === DUPLICATE_TRANSFER
                                ? shouldHaveTableName
                                : true)
                        );
                    }
                }
                case EDIT_TRANSFER:
                case SELECT_SOURCE: {
                    if (this.streamType === FULL_ARCHITECTURE) {
                        return (
                            isValueExist(this.selectedArchLevels) &&
                            R.any(R.prop('selected'), this.sourceList) &&
                            isSchedulesValid
                        );
                    } else {
                        const isBreakdownValid = R.ifElse(
                            R.always(this.isAnalytic),
                            R.always(true),
                            () =>
                                R.any(
                                    (breakdown) =>
                                        breakdown.selected &&
                                        REQUIRED_DIMENSION_CUSTOM_TABLE_WITH_MARKETRING_SOURCES.includes(
                                            breakdown.id
                                        )
                                )
                        )(this.breakdownList);

                        return (
                            R.all(
                                R.compose(
                                    isValueExist,
                                    R.filter(R.prop('selected'))
                                ),
                                [
                                    this.metricList,
                                    this.sourceList,
                                    this.breakdownList,
                                ]
                            ) &&
                            isBreakdownValid &&
                            isSchedulesValid &&
                            shouldHaveTableName
                        );
                    }
                }
                case SELECT_STREAM:
                case CONFIGURE_COLUMNS: {
                    return true;
                }
            }
        },
        observeSelectedItem$() {
            const { generateWatchNew$: gen$ } = this;

            const selectedItem$ = gen$('selectedItem').pipe(
                filter(isValueExist)
            );
            const formData$ = gen$('formData').pipe(
                filter((v) => {
                    const destName =
                        this.selectedItem?.dataTransferConfig
                            ?.destination_connector_type ?? '';
                    const isGoogleSheet = destName.includes('Google Sheets');
                    const isAPI = destName === 'API';
                    return isGoogleSheet || isAPI || isValueExist(v);
                }),
                take(1)
            );

            const combined$ = combineLatest(selectedItem$, formData$);

            this.$subscribeTo(combined$, ([item, formData]) => {
                const {
                    dataTransferConfig: {
                        custom_name,
                        destination_table_name,
                        asset_id_list = [],
                        data_to_transfer,
                        selected_breakdowns = [],
                        stream_type = '',
                        selected_arch_levels = [],
                        destination_connector_type,
                        connection_id,
                        schedules,
                        id,
                        schemas,
                    } = {},
                    dateFilter,
                    connectionConfiguration,
                    isDuplicate,
                } = item;
                this.page = isDuplicate ? DUPLICATE_TRANSFER : EDIT_TRANSFER;
                this.datastreamConnectionId = connection_id;

                const refined = formData.map((form) => {
                    const value = connectionConfiguration[form.key];

                    return value ? R.assoc('value', value, form) : form;
                });

                this.formData = refined;

                this._dateFilter = dateFilter || DEFAULT_DATE;

                this.metricList = data_to_transfer.map(
                    R.compose(R.assoc('selected', true), R.dissoc('type'))
                );

                const tableAdAccountsBhyAssetId = R.indexBy(
                    R.prop('assetId'),
                    this.tableAdAccounts
                );

                this.sourceList = asset_id_list.reduce((acc, val) => {
                    const source = tableAdAccountsBhyAssetId[val];

                    if (source) {
                        const selectedAssoced = R.assoc(
                            'selected',
                            true,
                            source
                        );

                        acc = [...acc, selectedAssoced];
                    }

                    return acc;
                }, []);

                this.streamType =
                    stream_type ||
                    (this.isAnalytic ? CUSTOM_TABLE : FULL_ARCHITECTURE);

                this.selectedArchLevels = selected_arch_levels || [];

                const transferType = this.transferOptions.find(
                    R.propEq('name', destination_connector_type)
                );

                this.breakdownList = selected_breakdowns.map((name) => ({
                    name,
                    id: name,
                    selected: true,
                }));

                this.valueMap = R.mergeLeft(
                    {
                        [NAME]: isDuplicate ? '' : custom_name,
                        [FREQUENCY]: {
                            value: schedules?.length
                                ? 24 / schedules.length
                                : '-',
                            display_name: schedules?.length
                                ? `${24 / schedules.length}h`
                                : '-',
                        },
                        [SCHEDULES]: schedules || [],
                        [TRANFER_TYPE]: transferType,
                        [TABLE_NAME]:
                            !isDuplicate &&
                            DESTINATION_TABLE_NAME_CONNECTORS.includes(
                                transferType?.name?.toLowerCase()
                            ) &&
                            stream_type === CUSTOM_TABLE
                                ? destination_table_name
                                : '',
                    },
                    this.valueMap
                );

                // this.schemas =
                //     (stream_type === FULL_ARCHITECTURE
                //         ? schemas?.report
                //         : schemas?.customTable) || [];

                if (this.isCustomFieldUser) {
                    this.getCustomFields(id);
                }
            });
        },
        closePanel() {
            if (isValueExist(this.selectedItem)) {
                this.$emit('setSelectedItem', {});
            }

            this.$emit('close');
        },
        renderSettingPanel() {
            const {
                active,
                renderContentsByPage,
                loading,
                onConfirmByPage,
                renderHeaderTextByPage,
                checkIsValidByPage,
                closePanel,
                confirmTextByPage,
                isUnblockPage,
                disabledReason,
                selectedSources,
            } = this;

            const drawerProps = {
                attrs: {
                    active,
                    onCancel: closePanel,
                    loadingMask: loading,
                    wrapStyle: { transform: 'unset' },
                    hasButtons: true,
                    confirmText: confirmTextByPage,
                    onConfirm: onConfirmByPage,
                    confirmDisabled: !checkIsValidByPage(),
                    closeOutside: false,
                    unblock: isUnblockPage,
                    disabledReason: disabledReason,
                    buttonTooltipPlacement: 'left',
                    selectedSources,
                    wrapClassName: 'ds-drawer',
                    width: this.page === CONFIGURE_COLUMNS ? '700' : '544',
                },
            };

            return (
                <div>
                    <Drawer {...drawerProps}>
                        {renderHeaderTextByPage()}
                        {renderContentsByPage()}
                        <VERTICAL_SPACER
                            amount={24}
                            style={{ 'flex-shrink': 0 }}
                        />
                    </Drawer>
                    <Iframe
                        src={this.iframeUrl}
                        resizing={false}
                        customWidth={'100%'}
                        customHeight={'100vh'}
                        ref="iframeCalendar"
                        overlayVisible={false}
                        style={{
                            position: 'fixed',
                            left: 0,
                            top: 0,
                        }}
                    />
                </div>
            );
        },
        closeCalendar() {
            this.postIframeMessage({
                type: IFRAME_EVENT_MESSAGE.TOGGLE_WIDGET_DATE_FILTER,
                origin: `VUE`,
                data: {
                    open: false,
                },
            });
        },
        async submitNotify() {
            this.loading = true;
            await ExportDataService.notifyCustom({
                dataStreamType: this.transferName.toLowerCase(),
                workspaceId: this.userAccountId,
                name:
                    this.valueMap.name ??
                    `${this.transferName}_${generateId().slice(0, 4)}`,
            });

            this.setNotiMsgs([
                {
                    type: NOTI_TYPES.SUCCESS,
                    title: this.$t('EXPORT_DATA.submit_done'),
                    reasons: [{}],
                },
            ]);
            this.loading = false;
            this.$emit('close');
        },
        async getCustomFields(id) {
            try {
                const data = await ExportDataService.getCustomFields(id);

                this.customFields = data;
            } catch (error) {
                console.error(error);
            }
        },
        renderMetricConfigurePanel() {
            if (!this.configurePanel) return null;

            const drawerProps = {
                attrs: {
                    active: this.configurePanel,
                    onCancel: () => (this.configurePanel = false),
                    hasButtons: false,
                    width: '700',
                    wrapStyle: { right: '544px', transform: 'unset' },
                    headerText: this.$t(
                        'EXPORT_DATA.panel_title_configure_columns'
                    ),
                },
            };

            const componentProps = {
                attrs: {
                    metricList: this.metricList,
                    schemas: this.schemas,
                    isEdit: true,
                    breakdowns: this.breakdownList,
                    streamType: this.streamType,
                    connectorType: this.isAnalytic ? 'GENERIC' : 'MARKETING',
                },
                on: {
                    setMetricList: (value) => (this.metricList = value),
                    setSchemas: (value) => (this.schemas = value),
                },
            };

            return (
                <Drawer {...drawerProps}>
                    <ConfigureColumns {...componentProps} />
                </Drawer>
            );
        },
        renderTargetFieldSetting() {
            return (
                <S.TargetFieldSettingWrapper
                    onClick={() => {
                        this.configurePanel = !this.configurePanel;
                    }}
                >
                    <TitleLabel>
                        <IconWrapper class="filter-icon-wrapper">
                            <FilterIcon v-view-box />
                            {this.$t(
                                'EXPORT_DATA.panel_title_configure_columns'
                            )}
                        </IconWrapper>
                        <S.EditButtonText>
                            {this.$t('COMMON.edit')}
                        </S.EditButtonText>
                    </TitleLabel>
                    <S.TargetFieldSettingDescription>
                        {this.$t(
                            'EXPORT_DATA.panel_description_configure_columns'
                        )}
                    </S.TargetFieldSettingDescription>
                </S.TargetFieldSettingWrapper>
            );
        },
    },
    mounted() {
        this.observeSelectedItem$();
        this.addIframeRef(this.$refs.iframeCalendar);
        this.addIframeRef(this.$refs.iframePanel);

        this.hideChatbot();

        this.$subscribeTo(secondPanelOpenSubject$, (v) => {
            v && this.closeCalendar();
        });
    },
    render() {
        return (
            <div>
                {this.renderSettingPanel()}
                {this.renderMetricConfigurePanel()}
                {/* panels — MetricPanel / BreakdownPanel 및 관련 overlay 패널 통합 iframe */}
                <Iframe
                    src={this.iframePanelUrl}
                    customWidth={'100%'}
                    customHeight={'100vh'}
                    ref="iframePanel"
                    overlayVisible={false}
                    style={(() => {
                        /**
                         * React → Vue SET_IFRAME_LAYER 메시지로 제어.
                         * none        : 패널 없음 → iframe이 클릭 이벤트를 막지 않도록 z-index 0
                         * secondPanel : MetricPanel/BreakdownPanel 열림 → WidgetSettingPanel 뒤에 위치
                         * customPanel : CustomMetricPanel/CustomBreakdownPanel 열림 → WidgetSettingPanel 위로 올라와야 함
                         */
                        const zIndexMap = {
                            none: 0,
                            secondPanel: 10,
                            customPanel: 12,
                        };
                        return {
                            position: 'fixed',
                            top: 0,
                            right: 0,
                            zIndex: zIndexMap[this.iframeLayer] ?? 0,
                            pointerEvents: this.iframeLayer === 'none' ? 'none' : 'auto',
                        };
                    })()}
                />
            </div>
        );
    },
};

export default withHMR(module, ExportDataPanel, ExportDataPanel.name);
